export const DELETED_RECORDS_TAB_URL_PARAM = 'tab';

export enum DeletedRecordsTab {
  PROJECTS = 'projects',
  ORDERS = 'orders',
  JOBS = 'jobs',
  TICKETS = 'tickets',
}

export const TICKET_PDF_MIME_TYPE = 'application/pdf';
